import { render } from "./Swiper.vue?vue&type=template&id=0745db1e"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__